import type { ValueProcessorLegacy } from '../../types/index.noReact';
import { defaultValueProcessorByRule } from './defaultValueProcessorByRule';
import { defaultValueProcessorCELByRule } from './defaultValueProcessorCELByRule';
import { defaultValueProcessorMongoDBByRule } from './defaultValueProcessorMongoDBByRule';
import { defaultValueProcessorSpELByRule } from './defaultValueProcessorSpELByRule';

const internalValueProcessors = {
  mongodb: defaultValueProcessorMongoDBByRule,
} as const;

const generateValueProcessor =
  (format: 'mongodb'): ValueProcessorLegacy =>
  (field, operator, value, valueSource, fieldType) =>
    internalValueProcessors[format](
      { field, operator, value, valueSource, fieldType },
      { parseNumbers: false }
    );

export const defaultMongoDBValueProcessor = generateValueProcessor('mongodb');
export * from './formatQuery';
export { defaultValueProcessorByRule };
export { defaultValueProcessorCELByRule };
export { defaultValueProcessorMongoDBByRule };
export { defaultValueProcessorSpELByRule };
